import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="w-full mt-20 pb-12 bg-background">
      <div className="flex flex-col md:flex-row justify-between items-center px-10 max-w-[1440px] mx-auto border-t border-white/10 pt-8">
        <p className="font-['Inter'] text-[0.6875rem] uppercase tracking-widest text-white/60 mb-6 md:mb-0">
          © {new Date().getFullYear()} The Editorial Pulse. Built for the Hyper-Digital Broadsheet.
        </p>
        <div className="flex flex-wrap justify-center gap-6">
          <Link to="#" className="font-['Inter'] text-[0.6875rem] uppercase tracking-widest text-white/60 hover:text-secondary transition-colors">Guidelines</Link>
          <Link to="#" className="font-['Inter'] text-[0.6875rem] uppercase tracking-widest text-white/60 hover:text-secondary transition-colors">FAQ</Link>
          <Link to="#" className="font-['Inter'] text-[0.6875rem] uppercase tracking-widest text-white/60 hover:text-secondary transition-colors">API</Link>
          <Link to="#" className="font-['Inter'] text-[0.6875rem] uppercase tracking-widest text-white/60 hover:text-secondary transition-colors">Security</Link>
          <Link to="#" className="font-['Inter'] text-[0.6875rem] uppercase tracking-widest text-white/60 hover:text-secondary transition-colors">Legal</Link>
          <Link to="#" className="font-['Inter'] text-[0.6875rem] uppercase tracking-widest text-white/60 hover:text-secondary transition-colors">Contact</Link>
        </div>
      </div>
    </footer>
  );
}
